import { Route } from 'react-router-dom';
import { lazyPage } from './lazyPage';

const ManageEnrolment = lazyPage(() => import('../pages/staff/keystone/ManageEnrolment'), 'ManageEnrolment');
const EnrolmentNew = lazyPage(() => import('../pages/staff/keystone/EnrolmentNew'), 'EnrolmentNew');
const EnrolmentEdit = lazyPage(() => import('../pages/staff/keystone/EnrolmentEdit'), 'EnrolmentEdit');
const NotesList = lazyPage(() => import('../pages/staff/keystone/NotesList'), 'NotesList');
const NoteComposer = lazyPage(() => import('../pages/staff/keystone/NoteComposer'), 'NoteComposer');
const BulkNote = lazyPage(() => import('../pages/staff/keystone/BulkNote'), 'BulkNote');
const NoteDetail = lazyPage(() => import('../pages/staff/keystone/NoteDetail'), 'NoteDetail');
const NoteEdit = lazyPage(() => import('../pages/staff/keystone/NoteEdit'), 'NoteEdit');
const Analytics = lazyPage(() => import('../pages/staff/keystone/Analytics'), 'Analytics');
const Eligibility = lazyPage(() => import('../pages/staff/keystone/Eligibility'), 'Eligibility');
const Settings = lazyPage(() => import('../pages/staff/keystone/Settings'), 'Settings');

/** Keystone pages for any Keystone member. */
export const keystoneMemberRoutes = (
  <>
    <Route path="/staff/keystone" element={<ManageEnrolment />} />
    <Route path="/staff/keystone/notes" element={<NotesList />} />
    <Route path="/staff/keystone/notes/new" element={<NoteComposer />} />
    <Route path="/staff/keystone/notes/bulk" element={<BulkNote />} />
    <Route path="/staff/keystone/notes/:id" element={<NoteDetail />} />
    <Route path="/staff/keystone/notes/:id/edit" element={<NoteEdit />} />
    <Route path="/staff/keystone/analytics" element={<Analytics />} />
  </>
);

/** Keystone pages for Leaders only. */
export const keystoneLeaderRoutes = (
  <>
    <Route path="/staff/keystone/enrolments/new" element={<EnrolmentNew />} />
    <Route path="/staff/keystone/enrolments/:id/edit" element={<EnrolmentEdit />} />
    <Route path="/staff/keystone/eligibility" element={<Eligibility />} />
    <Route path="/staff/keystone/settings" element={<Settings />} />
  </>
);
